module.exports = __webpack_public_path__ + "static/media/Follower_Button-25.8508a934.png";